import { useMemo } from 'react';
import { generateThemeBranding } from '../../common/utils/generate-theme-branding';
/**
 * Hook to access theme styles based on configuration
 * @param themeConfig - Custom theme configuration or undefined to use default
 * @returns ThemeStyles - Always returns valid theme styles
 */
export var useGenerateThemeBranding = function useGenerateThemeBranding(themeConfig) {
  return useMemo(function () {
    var theme = generateThemeBranding(themeConfig);
    return theme;
  }, [themeConfig]);
};